<template>
    <div class="reminder-background">
        <div class="reminder">
            <div class="reminder__body">
                <h1>Czy na pewno chcesz usunąć użytkownika?</h1>
                <p>Potwierdzenie spowoduje przypisanie zleceń usuwanego użytkownika do Ciebie.</p>
                <div class="reminder__footer">
                    <button class="button-normal button-normal--cancel" @click="$emit('cancel')">ANULUJ</button>
                    <button class="button-normal button-normal--media" @click="$emit('confirm')">POTWIERDŹ</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: 'warning',

}
</script>

<style lang="scss" scoped>

.reminder-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
    background:#000000a9
}

.reminder{
  background:#fff;
  border: 1px #d3020c solid;
  width: 400px;

  &__body{
    padding:30px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:100%;
     }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

  }

  &__footer{
      width:100%;
      display:flex;
      flex-direction: column;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }
}

</style>
